// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__rItOL","active":"Link_active__Ci8uJ","disabled":"Link_disabled__Ssb1N"};